<script>
  export let title;
  export let desc;
  export let img;
  export let innerMinHeight = 265;
</script>

<style>
  .banner-title {
    margin: 0;
    padding-bottom: 12px;
    line-height: 56px;
    font-size: 48px;
    font-family:  Gilroy-Bold, Gilroy;
  }
  .banner-desc {
    margin: 0;
    padding-top: 12px;
    font-weight: var(--fw2);
    font-size: 20px;
    line-height: 28px;
  }
  .banner {
    margin-top: -80px;
    padding: 120px 0 40px 0;
    width: 100%;
    background: #000;
    color: #fff;
  }
  .banner-inner {
    margin: 0 auto;
    width: 1200px;
  }
  .banner-content {
    width: 691px;
    font-family: Gilroy-Medium, Gilroy;
  }
  @media screen and (max-width: 640px) {
    .banner{
      margin-top: 0;
      padding: 40px 0 20px 0;
    }
    .banner-inner {
      display: block;
      padding-top: 16px;
      width: 92%;
    }
    .banner-title {
      padding-bottom: 0;
      line-height: 28px;
      font-size: 24px;
    }
    .banner-desc {
      padding-top: 12px;
      font-size: 12px;
    }
    .banner-content {
      width: 100%;
    }
  }
</style>

<div class="banner">
  <div class="banner-inner df jcsb pr" style="min-height: {innerMinHeight || 322}px">
    <div class="banner-content">
      <h2 class="banner-title">{@html title}</h2>
      {#if desc}
        <h3 class="banner-desc">{desc}</h3>
      {/if}
      <slot />
      <slot name="link" />
    </div>
    <slot name='banner-img'/>
  </div>
</div>
